import { oc } from '@orpc/contract';
import { listBoardBindingsInputSchema, listBoardBindingsOutputSchema } from '../schemas/board.schemas.js';
export const listBoardBindingsContract = oc
    .route({
    method: 'GET',
    path: '/board/bindings',
    tags: ['Board'],
    summary: 'Every board metric key with its expected unit/currency and the KPI it is bound to (every role)',
})
    .input(listBoardBindingsInputSchema)
    .output(listBoardBindingsOutputSchema);
//# sourceMappingURL=list-board-bindings.contract.js.map